export default "__VITE_ASSET__DpVod7V0__"